// extracted by mini-css-extract-plugin
export default {"copyButton":"CopyButton_copyButton__-Ej08"};